
<div *ngIf="done">
    <div class="alert alert-success">
        Der er blevet sendt en email til dig med et nulstillingslink!
    </div>
</div>
<div  class="loginForm" *ngIf="!done">
    <form [formGroup]="sendEmailFormGroup">
        <h2 class="text-center">Nulstil kodeord</h2>
        <div *ngIf="wrongInput" class="alert alert-danger">
            {{wrongInputReason}}
        </div>
        <div class="form-group">
            <input class="form-control input-lg" placeholder="Brugernavn" formControlName="username">
        </div>
        
        <!--<div class="form-group">
            <input class="form-control input-lg" type="password" placeholder="Kodeord" formControlName="password">
        </div>-->
        <div class="form-group">
            <button type="submit" class="btn btn-primary btn-lg btn-block"  (click)="onSubmit()">Send nulstillings-email</button>
        </div>
    </form>
</div>